<template>
  <div class="min-h-screen bg-zinc-950 p-8 text-zinc-100 flex items-center justify-center">
    <div class="bg-zinc-900 p-12 rounded-2xl shadow-sm border border-zinc-800 text-center max-w-md w-full space-y-6">
      <div v-if="loading" class="space-y-4">
        <div class="w-12 h-12 border-4 border-green-500/20 border-t-green-500 rounded-full animate-spin mx-auto"></div>
        <h2 class="text-xl font-bold">Connexion à Spotify...</h2>
        <p class="text-zinc-500 text-sm">Veuillez patienter pendant que nous sécurisons votre session.</p>
      </div>
      
      <div v-else-if="error" class="space-y-4">
        <div class="w-12 h-12 bg-red-900/30 text-red-500 rounded-full flex items-center justify-center mx-auto">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </div>
        <h2 class="text-xl font-bold text-red-500">Erreur de connexion</h2>
        <p class="text-zinc-400 text-sm">{{ error }}</p>
        <router-link to="/" class="inline-block mt-4 text-green-500 font-medium hover:underline">Retour au tableau de bord</router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const loading = ref(true)
const error = ref('')

onMounted(async () => {
  const code = route.query.code as string
  if (!code) {
    error.value = "Aucun code d'autorisation fourni par Spotify."
    loading.value = false
    return
  }

  try {
    const token = localStorage.getItem('apiToken')
    const response = await fetch('/api/music/spotify/exchange', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ code })
    })

    const data = await response.json()
    if (data.success) {
      router.push('/')
    } else {
      error.value = data.error || 'Erreur lors de la validation du code.'
    }
  } catch (e) {
    console.error(e)
    error.value = 'Erreur réseau.'
  } finally {
    loading.value = false
  }
})
</script>
